// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_1LPaj","dialog__header":"_3nxhf","dialog__body":"_3LGaW","dialog__variant":"_1t1iY"};